import InPageNavContainer from './container';
export default InPageNavContainer;
